<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <horizontal-stepper 
          :steps="steps" 
          locale="es"
          @completed-step="completeStep"
          @active-step="isStepActive" 
          @stepper-finished="registrarPago"
          :keep-alive="Boolean(true)"
          :top-buttons="Boolean(true)">
        </horizontal-stepper>          
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import PagoPersonal from './PagoPersonal.vue';
import PagoDocumentos from './PagoDocumentos.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldosPagos/getField',
  mutationType: 'liquidacionSueldosPagos/updateField',
});

export default {
  name: 'ABM',
  components: {
    HorizontalStepper,
    PagoPersonal,
    PagoDocumentos,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      steps: [
          {
              icon: '',
              name: 'pago-personal',
              title: 'Selección del Personal',
              subtitle: 'Seleccione el personal a incluir',
              component: PagoPersonal,
              completed: false

          },
          {
              icon: '',
              name: 'pago-documentos',
              title: 'Selección de la Forma de Pago',
              subtitle: 'Seleccione la forma de pago',
              component: PagoDocumentos,
              completed: false
          },
      ],
    }
  },
  computed: {
    ...mapFields([
      'periodo',
      'liquidacionesPersonal',
    ]),
  },  
  created() {
    let liquidacionSueldosId = this.$route.params.liquidacionSueldosId;

    this.showSpinner();
    this.$store.dispatch('liquidacionSueldosPagos/inicializar', liquidacionSueldosId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
                // console.log(step);
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    registrarPago () {
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/save')
        .then(() => this.showModalMsj('Los pagos se registraron con éxito', this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: 'LiquidacionesSueldos' });
    },
  },
  validations: {
  },  
  watch: {
  }    
}
</script>
